import {
	Registrar_2_ConcludedCases,
	Registrar_2_Dashboard,
	Registrar_2_MyFiles,
	Registrar_2_Notification,
	Registrar_2_Profile,
} from '../features/registrar-2';
import ProcessPayment from '../features/registrar-2/proceed-payment';

export const registrar_2_Routes = [
	{
		id: '1',
		title: 'Dashboard',
		component: Registrar_2_Dashboard,
		path: 'registrar-2',
	},
	{
		id: '2',
		title: 'Case Folders',
		component: Registrar_2_MyFiles,
		path: 'registrar-2/case-folders',
	},
	{
		id: '3',
		title: 'Notification',
		component: Registrar_2_Notification,
		path: 'registrar-2/notification',
	},
	{
		id: '4',
		title: 'Profile',
		component: Registrar_2_Profile,
		path: 'registrar-2/profile',
	},

	{
		id: '6',
		title: 'Concluded Cases',
		component: Registrar_2_ConcludedCases,
		path: 'registrar-2/concluded-cases',
	},
	{
		id: '7',
		title: 'process',
		component: ProcessPayment,
		path: 'registrar-2/process',
	},
];
